<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import {resetPc} from './utils/adapter';
export default {
  name: 'App',
  mounted() {
      resetPc();
  },
}
</script>
<style>
@import './css/app.css';
</style>


// WEBPACK FOOTER //
// src/App.vue